export const iconFontAwesomeTransportationMotorcycle = (
	<i className="fa-solid fa-motorcycle"></i>
);
